<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  @if (!isInModalContext) {
    <button
      *ngPermissions="permissionService.Permission.campaign_create"
      sb-button-primary
      type="button"
      color="green"
      icon="plus"
      sbTooltip="{{ 'lang.globals.create' | translate }}" container="body"
      [iconButton]="true"
      [sbRouterLink]="util.RoutingID.campaignCreate"
      [queryParams]="{returnTo: util.getPageLink()}">
    </button>
    <button
      type="button"
      sb-button-primary
      icon="refresh"
      [iconButton]="true"
      [color]="'blue'"
      (click)="requestDebounced()"
      [disabled]="loading()"
      [loading]="loading()"
      sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
      placement="top">
    </button>
    <button
      *ngPermissions="permissionService.Permission.campaign_report"
      type="button"
      sb-button-primary
      icon="refresh"
      sbTooltip="{{ 'lang.globals.export' | translate }}" container="body"
      [iconButton]="true"
      [color]="'blue'"
      icon="download"
      [disabled]="true"
      (click)="showSideBar= true">
      <!--
      <span class="d-none d-md-inline-block">{{ 'lang.globals.export'|translate }}</span>
      -->
    </button>
  }
</ng-container>
<!------------------------------

    Side Panel

------------------------------->

<sb-comp-side-panel
  (showChange)="showSideBar = $event" [show]="showSideBar"
  [sidebarHeader]="sidePanelHeaderExport"
  [sidebarTemplate]="sidePanelTemplateExport"
  [sidebarFooter]="sidePanelFooterExport"
  [width]="600">

</sb-comp-side-panel>

<ng-template #sidePanelHeaderExport>
  <h4>{{ 'lang.globals.createCampaignReport' | translate }}</h4>
</ng-template>

<ng-template #sidePanelTemplateExport>
  <form [formGroup]="form" class="">
    <div class="form-group validateMe">
      <label class="form-label" for="Title">{{ 'lang.globals.title' | translate }}</label>
      <input type="text" id="Title" class="form-control" formControlName="Title"
             sbAutofocus>
    </div>
    <div class="form-group">
      <sb-local-date-time-input
        class="w-100"
        [title]="translate.instant('lang.globals.startTime')" [seconds]="false"
        [kind]="'RANGE_START'"
        (modelChange)="localDateTimeInputFrom($event)">
      </sb-local-date-time-input>
    </div>
    <div class="form-group">
      <sb-local-date-time-input
        class="w-100"
        [title]="translate.instant('lang.globals.dueTime')" [seconds]="false"
        [kind]="'RANGE_END'"
        [minDate]="reportFrom"
        (modelChange)="localDateTimeInputTill($event)"></sb-local-date-time-input>
    </div>
  </form>
</ng-template>

<ng-template #sidePanelFooterExport>
  <div class="tw-flex tw-justify-between">
    <button
      sb-button-secondary
      type="button"
      [color]="'red'"
      [icon]="'cancel'"
      (click)="showSideBar = false; form.reset()"
    >{{ 'lang.globals.cancel' | translate }}
    </button>
    <button
      sb-button-secondary
      type="button"
      [color]="'blue'"
      [icon]="'save'"
      [disabled]="form.invalid"
      (click)="createCampaignReport()"
    >{{ 'lang.globals.save' | translate }}
    </button>
  </div>
</ng-template>
<!------------------------------

    Table Wrapper

------------------------------->

@let isExpanded = checkExpansion();
@let ordering = orderOption();
<sb-table-wrapper-new
  headline="{{'lang.headlines.campaigns' | translate}}" [itemsData]="campaigns"
  [isInModalContext]="isInModalContext"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  class="tw-w-full"
  [isFilterPanelOpen]="isExpanded"
  [isMultiSelectEnabled]="selectedCampaigns?.size >0"
  [itemName]="'campaigns'"
>
  <!------------------------------

      Filter

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section
        [initiallyExpanded]="true"
        title="{{'lang.globals.statusFilter' |translate}}" icon="toggleOn"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-toggle filterID="timingPlanned" [default]="true" [label]="'lang.globals.planned' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="timingActive" [default]="true" [label]="'lang.globals.running' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="timingEnded" [label]="'lang.globals.expired' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="timingUnknown" [default]="true" [label]="'lang.globals.noTiming' | translate"></sb-filter-toggle>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.cull_list" title="{{'lang.globals.contentFilter' | translate}}"
                         icon="screenPlay">
        <sb-filter-dto-list-select filterID="contentCulls" [endpoint]="api.cs_Cull_retrieveAll.bind(api)"
                                   [endpointOptions]="{type: 'ContentCull'}">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="companies" [isSingleSelect]="true" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.campaign_type_list"
                         title="{{'lang.globals.campaignTypes' | translate}}" icon="megaphoneTypes">
        <sb-filter-dto-list-select filterID="campaignTypes" [endpoint]="api.ca_md_CampaignType_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

      <div class="tw-mx-5 tw-gap-2.5 tw-flex tw-flex-col">
        <div
          #filterPanelTimeRange
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-group tw-w-fit "
          [ngClass]="{'tw-cursor-pointer': !isExpanded}"
          (click)="!isExpanded?openFilterPanel(filterPanelTimeRange):scrollToFilterPanelElement(filterPanelTimeRange)">
          <sb-icon class="" icon="calendar"></sb-icon>
          <div class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-text-lg tw-flex-1"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.timeRange' | translate }}
          </div>
        </div>

        @if (isExpanded) {
          <sb-local-date-range-input
            class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out"
            [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-auto': isExpanded,
    }"
            [displayMonths]="1"
            [from]="from" [till]="till" [showSubmit]="true" [today]="null" [allowEmpty]="true"
            (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
        }
      </div>


      <ng-template #orderSection>
        <sb-filter-section
          [alwaysExpanded]="true" [hideValueIndicatorIfDefaultSelected]="true" [showTag]="false"
          title="{{'lang.globals.order' | translate}}" icon="sort">
          <sb-filter-order
            [allOrderOptions]="allOrderOptions|omit: 'direction'"
            [selectedOrderOption]="orderOption()"
          >
          </sb-filter-order>
        </sb-filter-section>
      </ng-template>
    </sb-filter-panel>
  </div>

  <!------------------------------

          Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        <sb-comp-table-multi-select-button [selectionState]="selectionState"
                                           (action)="selectAction($event)"></sb-comp-table-multi-select-button>
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.LEVEL)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.LEVEL}">
        {{ 'lang.globals.level' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.LEVEL) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>Status</th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.NAME)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.NAME}">
        {{ 'lang.globals.campaign' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.NAME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="">{{ 'lang.globals.customer' | translate }}
        / {{ 'lang.globals.campaignType' | translate }}
      </th>
      <th>{{ 'lang.globals.verification' | translate }}</th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.FROM_TIME)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.FROM_TIME}">
        {{ 'lang.globals.timingProgress' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.FROM_TIME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>
        {{ 'lang.campaignEdit.budget' | translate }} / {{ 'lang.globals.targeting' |translate }}
      </th>
      <th *ngPermissions="permissionService.Permission.ds_cm_reporting"
          class="d-lg-table-cell d-none">{{ 'lang.globals.playoutPulse' | translate }}
      </th>
      <th>{{ 'lang.globals.playouts' | translate }}</th>
      <th>{{ 'lang.globals.filter' | translate }}</th>
      <th class="">{{ 'lang.globals.locationsScreens' | translate }}</th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.MODIFIED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.MODIFIED_AT}">
        {{ 'lang.globals.modifiedAt' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.MODIFIED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

        Card  Table Header

  ------------------------------->
  <ng-template #tCardHead>
    <tr>
      <th>
        <sb-comp-table-multi-select-button [selectionState]="selectionState"
                                           (action)="selectAction($event)"></sb-comp-table-multi-select-button>
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.LEVEL)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.LEVEL}">
        {{ 'lang.globals.level' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.LEVEL) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.NAME)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.NAME}">
        {{ 'lang.globals.campaign' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.NAME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.FROM_TIME)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.FROM_TIME}">
        {{ 'lang.globals.timingProgress' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.FROM_TIME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>

      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Campaign_retrieveAllFrontendEnhanced_order.MODIFIED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Campaign_retrieveAllFrontendEnhanced_order.MODIFIED_AT}">
        {{ 'lang.globals.modifiedAt' | translate }}
        @if (ordering.value === ds_cm_Campaign_retrieveAllFrontendEnhanced_order.MODIFIED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
    </tr>
  </ng-template>
  <!------------------------------

      SelectionMode

------------------------------->
  <ng-template #tSelectionMode>
    <sb-action-bar [isInModalContext]="isInModalContext">
      <!-- projected info -->
      <div info>
        {{ selectedCampaigns.size }} {{ 'lang.globals.selected' | translate }}
      </div>

      <!-- deselect button -->
      <button
        deselect
        type="button"
        sb-button-secondary
        [color]="'blue'"
        class="tw-text-nowrap"
        (click)="selectAction('deselectAll')">
        {{ 'lang.multiSelect.deselectAll'|translate }}
      </button>

      <!-- actions -->
      <button
        *ngPermissions="permissionService.Permission.campaign_report"
        actions
        type="button"
        sb-button-primary
        [color]="'blue'"
        icon="download"
        (click)="openSidePanelCreateCampaignExport()"
        [disabled]="selectedCampaigns.size === 0 || showSideBar">
        {{ 'lang.globals.export'|translate }}
      </button>


    </sb-action-bar>
  </ng-template>

  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-campaign>
    <!--
    @let campaign = identity(data);
    -->
    <tr [style.height.px]="rowHeight()" [ngClass]="{'tw-opacity-50' : !campaign.active}" (mouseover)="campaign.interval = 2000"
        (mouseout)="campaign.interval = 0">
      <td>
        @let isCampaignSelected = selectedCampaigns.has(campaign?.id) ?? false;
        <sb-comp-table-select-button [isSelected]="isCampaignSelected" (action)="selectCampaign(campaign)"></sb-comp-table-select-button>
      </td>
      <td>{{ campaign?.level.id.level }}</td>
      <td>
        <sb-action-required [bookingStatus]="campaign.bookingStatus"></sb-action-required>
      </td>
      <td>
        <sb-comp-image-name-wrapper [medium]="campaign?.preview" [tooltipInterval]="campaign.interval"
                                    [customWidth]="'70px'" [customHeight]="'70px'" [thumbnailSize]="'XS'"
                                    [still]="true" [hideArrows]="true" [hideIndicators]="true">
          <sb-comp-link
            firstLine class="tw-cursor-pointer"
            [title]="campaign.name | truncate : 23"
            [permission]="permissionService.Permission.campaign_list"
            [tooltip]="'lang.globals.openDetails' | translate"
            [link]="util.RoutingID.commercials" [pathParams]="[{id: 'campaignID', value: campaign?.id}]"
            [queryParams]="{
              timingActive: timingActive,
               timingEnded: timingEnded,
                timingPlanned: timingPlanned,
                 timingUnknown: timingUnknown,
                  contentCulls: JSON.stringify(selectedContentCullIds)
                  }">
          </sb-comp-link>
          <sb-comp-commercial-count secondLine class="tw-m-0" [currentTimingFilter]="getTimingSelections()"
                                    [commercialCount]="campaign?.commercialCount"></sb-comp-commercial-count>

          <sb-tags thirdLine *ngPermissions="[permissionService.Permission.tag_list]" [tags]="campaign.tags"
                   [dtoType]="tagService.TaggableDTO.Campaign" [dtoId]="campaign.id"></sb-tags>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        <ul class="tw-gap-2">
          <li class="tw-flex tw-items-center tw-gap-2">
            <sb-icon icon="user"></sb-icon>
            <span [innerHTML]="campaign?.customer?.name | truncate : 20"></span>
          </li>
          <li class="tw-flex tw-items-center tw-gap-2"
              [ngClass]="{'tw-text-sbGray-600' : !campaign.campaignType}">
            <sb-icon icon="megaphoneTypes"></sb-icon>
            <span
              [innerHTML]="(campaign?.campaignType?.name ?? '-') | truncate : 20"></span>
          </li>
        </ul>
      </td>
      <td>
        <sb-verification-progress [bookingStatus]="campaign.bookingStatus"></sb-verification-progress>
      </td>
      <td>
        <sb-comp-progressbar-wrapper [campaignOrCommercial]="campaign"></sb-comp-progressbar-wrapper>
      </td>
      <td>
        <ul class="tw-flex tw-flex-col tw-gap-2">
          @let budget = campaign?.budget;
          <li class="tw-flex tw-items-center tw-gap-2"
              [ngClass]="{'tw-text-sbGray-600' : !budget}">
            <sb-icon ngbTooltip="Budget" container="body" icon="budgetCoin"></sb-icon>
            <div>{{ budget ? ((budget.amount  | sbNumberFormat) + ' ' + budget.currency.symbol) : '-' }}</div>
          </li>
          @let targeting = campaign?.targeting;
          <li class="tw-flex tw-items-center tw-gap-2"
              [ngbTooltip]="targeting? ((('lang.targeting.target.'+ targeting.target ) | translate) + ' - ' + (('lang.targetingAndBudget.timingRelations.'+ targeting.relation ) | translate) +' - ' + (targeting.amount  | sbNumberFormat )) : ''"
              [ngClass]="{'tw-text-sbBlue-500 dark:tw-text-white' : targeting, 'tw-text-sbGray-600' : !targeting}"
          >
            <sb-icon ngbTooltip="{{'lang.globals.targeting'| translate}}" container="body" icon="targeting"></sb-icon>
            <div [innerHTML]="targeting?.name ?? '-' | truncate: 12"
                 [ngClass]="{'tw-text-sbBlue-500 dark:tw-text-white dark:tw-bg-sbGrayBlue-800 tw-rounded-full tw-bg-sbBlue-50 tw-py-2 tw-px-4' : targeting}"
            ></div>
          </li>
        </ul>
      </td>
      <td *ngPermissions="permissionService.Permission.ds_cm_reporting">
        <div *ngIf="campaign?.reporting?.loadingDone">
          <sb-line-small-chart [chartData]="campaign.reporting"></sb-line-small-chart>
        </div>
      </td>
      <td>
        <sb-comp-playout-aggregation [playoutAggregation]="campaign?.playoutAggregation"></sb-comp-playout-aggregation>
      </td>
      <td>
        <sb-comp-filter-overview [timeCull]="campaign?.timeCull" [geoCull]="campaign?.geoCull"
                                 [stateSpaceCull]="campaign?.stateSpaceCull" [playerCull]="campaign?.playerCull">
        </sb-comp-filter-overview>
      </td>
      <td>
        <ul class="tw-gap-2">
          <li class="tw-flex tw-items-center tw-gap-2">
            <sb-icon icon="location"></sb-icon>
            <div>{{ campaign?.playerAggregation?.locations | sbNumberFormat }}</div>
          </li>
          <li class="tw-flex tw-items-center tw-gap-2">
            <sb-icon icon="screen"></sb-icon>
            <div>
              {{ campaign?.playerAggregation?.screens | sbNumberFormat }}
            </div>
          </li>
        </ul>
      </td>

      <td>
        <sb-comp-display-modified [data]="campaign"></sb-comp-display-modified>
      </td>
      <td class="sticky-col last-col">
        <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: campaign}"></ng-container>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->

  <ng-template #card let-campaign>
    <sb-table-card>
      <div table-card-header>
        @let isCampaignSelected = selectedCampaigns.has(campaign?.id) ?? false;
        <sb-comp-table-select-button [isSelected]="isCampaignSelected" (action)="selectCampaign(campaign)"></sb-comp-table-select-button>
      </div>

      <div table-card-header-more>
        <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: campaign}"></ng-container>
      </div>
      <div table-card-img>
        <sb-preview-tooltip [interval]="5000" [hoverPreview]="false" [showFullOnClick]="true"
                            [customWidth]="'100%'" [customHeight]="'240px'" [still]="true"
                            [previews]="campaign?.preview"></sb-preview-tooltip>
      </div>
      <!--
      <div table-card-sub-header>
        <div class="tw-flex tw-justify-between tw-items-center">
          <div>
            <a class="link cursor-help"
               ngbTooltip="{{ 'lang.globals.modifiedBy' | translate: { modifiedBy: campaign?.createdBy?.name? campaign?.modifiedBy?.name ? campaign?.modifiedBy?.name : campaign?.createdBy?.name : ('lang.globals.unknown'|translate) } }}"
               placement="top"
               container="body">{{ dateTransformation.modifiedCheck(campaign)?.toString()   | date: 'dd.MM.yy HH:mm:ss' }}</a>
          </div>

          <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: campaign}"></ng-container>
        </div>
      </div>
      -->
      <div table-card-body>
        <div
          class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:tw-py-3.5 *:sm:tw-py-5">
          <sb-table-card-element
            class=""
            [orientation]="'left'" [headline]="'lang.globals.campaign' | translate">
            <sb-comp-link
              [tooltip]=" 'lang.globals.openDetails' | translate "
              [title]="campaign.name | truncate : 13"
              [link]="util.RoutingID.commercials"
              [permission]="permissionService.Permission.campaign_list"
              [pathParams]="[{id: 'campaignID', value: campaign?.id}]" [classes]="'headline'"
              [queryParams]="{
                              timingActive: timingActive,
                              timingEnded: timingEnded,
                              timingPlanned: timingPlanned,
                              timingUnknown: timingUnknown,
                              contentCulls: JSON.stringify(selectedContentCullIds)}"
            >
            </sb-comp-link>
          </sb-table-card-element>
          <sb-table-card-element class="" [headline]="'lang.globals.commercial' | translate " [orientation]="'right'"
                                 [classes]="'tw-gap-2'">
            <sb-icon icon="commercial"></sb-icon>
            <sb-comp-commercial-count class="tw-m-0" [commercialCount]="campaign?.commercialCount"></sb-comp-commercial-count>
          </sb-table-card-element>
          <sb-table-card-element class="" [headline]="'Status'"
                                 [orientation]="'left'">
            <sb-action-required [bookingStatus]="campaign.bookingStatus"></sb-action-required>
          </sb-table-card-element>
          <sb-table-card-element class=""
                                 [headline]="('lang.globals.customer' | translate) +'/'+ ('lang.globals.campaignType' | translate )"
                                 [orientation]="'right'">
            <ul class="tw-flex tw-flex-col tw-gap-2 sm:*:tw-flex-row-reverse">
              <li class="tw-flex tw-items-center tw-gap-2">
                <sb-icon icon="user"></sb-icon>
                <span [innerHTML]="campaign?.customer?.name | truncate : 20"></span>
              </li>
              <li class="tw-flex tw-items-center tw-gap-2"
                  [ngClass]="{'tw-text-sbGray-600' : !campaign?.campaignType}">
                <sb-icon icon="megaphoneTypes"></sb-icon>
                <span
                  [innerHTML]="(campaign?.campaignType?.name ?? '-') | truncate : 20"></span>
              </li>
            </ul>
          </sb-table-card-element>
          <sb-table-card-element [classes]="'tw-gap-2'" [headline]=" 'lang.globals.level' | translate " [orientation]="'left'">
            <sb-icon icon="level"></sb-icon>
            <span [innerHTML]="campaign?.level?.id?.level"></span>
          </sb-table-card-element>
          <sb-table-card-element class="" [headline]=" 'lang.globals.locationsScreens' | translate " [orientation]="'right'">
            <ul class=" tw-flex tw-flex-col tw-gap-2 sm:*:tw-flex-row-reverse">
              <li class="tw-flex tw-items-center tw-gap-2">
                <sb-icon icon="location"></sb-icon>
                <div>{{ campaign?.playerAggregation?.locations | sbNumberFormat }}</div>
              </li>
              <li class="tw-flex tw-items-center tw-gap-2">
                <sb-icon icon="screen"></sb-icon>
                <div>
                  {{ campaign?.playerAggregation?.screens | sbNumberFormat }}
                </div>
              </li>
            </ul>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-1" [headline]=" 'lang.globals.verification' | translate " [orientation]="'left'">
            <sb-verification-progress [bookingStatus]="campaign.bookingStatus"></sb-verification-progress>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-3" [headline]=" 'lang.globals.timingProgress' | translate " [orientation]="'right'">
            <sb-comp-progressbar-wrapper class="tw-w-full" [campaignOrCommercial]="campaign"></sb-comp-progressbar-wrapper>
          </sb-table-card-element>
          <sb-table-card-element class="" *ngPermissions="permissionService.Permission.ds_cm_reporting"
                                 [headline]="'lang.globals.playoutPulse' | translate " [orientation]="'left'">
            <div *ngIf="campaign?.reporting?.loadingDone">
              <sb-line-small-chart [chartData]="campaign.reporting"></sb-line-small-chart>
            </div>
          </sb-table-card-element>
          <sb-table-card-element class="" [headline]=" 'lang.globals.playouts' | translate" [orientation]="'right'">
            <sb-comp-playout-aggregation [playoutAggregation]="campaign?.playoutAggregation"></sb-comp-playout-aggregation>
          </sb-table-card-element>
          <sb-table-card-element class="" [headline]=" 'lang.globals.filter' | translate " [orientation]="'left'">
            <sb-comp-filter-overview [timeCull]="campaign?.timeCull" [geoCull]="campaign?.geoCull"
                                     [stateSpaceCull]="campaign?.stateSpaceCull" [playerCull]="campaign?.playerCull">
            </sb-comp-filter-overview>
          </sb-table-card-element>
          <sb-table-card-element class=""
                                 [headline]="('lang.campaignEdit.budget' | translate) +'/'+ ('lang.globals.targeting' | translate )"
                                 [orientation]="'right'">
            <ul class="tw-flex tw-flex-col tw-gap-2 sm:*:tw-flex-row-reverse">
              @let budget = campaign?.budget;
              <li class="tw-flex tw-items-center tw-gap-2"
                  [ngClass]="{'tw-text-sbGray-600' : !budget}">
                <sb-icon ngbTooltip="Budget" container="body" icon="budgetCoin"></sb-icon>
                <div>{{ budget ? ((budget.amount  | sbNumberFormat) + ' ' + budget.currency.symbol) : '-' }}</div>
              </li>
              @let targeting = campaign?.targeting;
              <li class="tw-flex tw-items-center tw-gap-2"
                  [ngbTooltip]="targeting? ((('lang.targeting.target.'+ targeting.target ) | translate) + ' - ' + (('lang.targetingAndBudget.timingRelations.'+ targeting.relation ) | translate) +' - ' + (targeting.amount  | sbNumberFormat )) : ''"
                  [ngClass]="{'tw-text-sbBlue-500 dark:tw-text-white' : targeting, 'tw-text-sbGray-600' : !targeting}"
              >
                <sb-icon ngbTooltip="{{'lang.globals.targeting'| translate}}" container="body" icon="targeting"></sb-icon>
                <div [innerHTML]="targeting?.name ?? '-' | truncate: 12"
                     [ngClass]="{'tw-text-sbBlue-500 dark:tw-text-white dark:tw-bg-sbGrayBlue-800 tw-rounded-full tw-bg-sbBlue-50 tw-py-2 tw-px-4' : targeting}"
                ></div>
              </li>
            </ul>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-border-0" [headline]="'lang.globals.modifiedAt' | translate" [orientation]="'left'">
            <sb-comp-display-modified [data]="campaign"></sb-comp-display-modified>
          </sb-table-card-element>
        </div>
      </div>
    </sb-table-card>
  </ng-template>
</sb-table-wrapper-new>


<ng-template #ActionButtons let-campaign>
  <div class="tw-flex tw-gap-2.5">
    @if (!isInModalContext) {
      @if (permissionService.hasPermission(permissionService.Permission.campaign_edit)) {
        @if (campaign.active) {
          <button
            sb-button-secondary
            [iconButton]="true"
            [color]="'blue'"
            [icon]="'pause'"
            (click)="toggleCampaignEnabled(campaign, !campaign.active)">
          </button>
        } @else {
          <button
            sb-button-secondary
            [color]="'green'"
            [iconButton]="true"
            (click)="toggleCampaignEnabled(campaign, !campaign.active)"
            [icon]="'play'"
          >
          </button>
        }
      }
      <sb-split-button
        [splitButtonItems]="campaign.sbButtons ?? []"
        (selectedAction)="resolveSplitButtonAction(campaign, $event)"
      ></sb-split-button>
    }
    @if (isInModalContext && modalType === 'reservation') {

      <button
        type="button"
        sb-button-secondary
        [color]="'blue'"
        class="tw-px-2"
        (click)="selectCampaign(campaign)"
      >
        <sb-icon [icon]="'boxChecked'"></sb-icon>
      </button>
    }
  </div>
</ng-template>
